import { render, staticRenderFns } from "./session-expired.vue?vue&type=template&id=a55761cc&scoped=true"
import script from "./session-expired.vue?vue&type=script&lang=js"
export * from "./session-expired.vue?vue&type=script&lang=js"
import style0 from "./session-expired.vue?vue&type=style&index=0&id=a55761cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55761cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a55761cc')) {
      api.createRecord('a55761cc', component.options)
    } else {
      api.reload('a55761cc', component.options)
    }
    module.hot.accept("./session-expired.vue?vue&type=template&id=a55761cc&scoped=true", function () {
      api.rerender('a55761cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/session-expired.vue"
export default component.exports